import React, { useEffect, useState } from "react";
import { AppThemeRequestProvider } from "../../../context/ThemeRequestContext";
import SuccessIMG from "../../../assets/success.png";
import { Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import Controls from "../../../components/controls/Controls";

export default function SuccessFormDataStep(props: any) {

  const [protocolo, setProtocolo] = useState("");

  useEffect(() => {
    if (props.location.state === undefined) {
      props.history.replace("/");
    } else {
      setProtocolo(props.location.state.protocol);
    }
  }, [props.history, props.location.state]);

  return (
    <AppThemeRequestProvider>
        <Grid container>
          <Grid item xs={7}>
            <Grid>
              <Grid item>
                <Typography style={{fontSize: "3.7em", color: "#000", fontWeight: "700", fontFamily: "Inter",   marginBottom:'3%', lineHeight: 1.3}}>
                  Sua solicitação <br/>foi realizada com sucesso!
                </Typography>
              </Grid>
              <Grid item>
                <Typography style={{fontSize: "1.7em", color: "#000", fontWeight: "400", fontFamily: "Inter", marginBottom:'3%'}}>
                  Protocolo <strong>{protocolo}</strong>
                </Typography>
              </Grid>
              <Grid style={{fontSize: "1em", lineHeight: 1.3, color: "#000", fontWeight: "400", fontFamily: "Inter", marginBottom:'3%'}}>
                <p>
                  Para mais informações, entrar em contato com o
                  <strong> SAM – Serviço
                  de Apoio ao Médico.</strong>
                </p>
                
              </Grid>
              <Grid style={{fontSize: "1em", lineHeight: 1.3, color: "#000", fontWeight: "400", fontFamily: "Inter",  marginBottom:'3%'}}>
                <p>
                  SAM SP - Atendimento de segunda a sexta-feira, das
                  <strong> 7h às 18h30. </strong>
                </p>
                <p>
                  <strong> (11) 3394-1000 sam@hsl.org.br </strong>
                </p>
              </Grid>
              <Grid style={{fontSize: "1em", lineHeight: 1.3, color: "#000", fontWeight: "400", fontFamily: "Inter",  marginBottom:'5%'}}>
                <p>
                  SAM BSB - Atendimento de segunda a sexta-feira, das{" "}
                  <strong> 8h às 18h30. </strong>{" "}
                </p>
                <p>
                  {" "}
                  <strong>
                    {" "}
                    (61) 3044-8888 (opção 6) sambrasilia@hsl.org.br{" "}
                  </strong>
                </p>
              </Grid>
              <Grid item >
                <Link to="/">
                  <Controls.Button text="Voltar ao início" type="Success" />
                </Link>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={5}>
            <Grid item>
              <img src={SuccessIMG} style={{ width: "100%",   marginTop: "10%",}} alt="Imagem de Sucesso!" />
            </Grid>
          </Grid>
        </Grid>

    </AppThemeRequestProvider>
  );
}
